import { Navigate } from "react-router-dom";
import { useSalonStore } from "@/lib/store/salon";

export function ConditionalRedirect() {
  const currentSalon = useSalonStore((state) => state.currentSalon);

  if (currentSalon?.role.includes("WORKER")) {
    return <Navigate to="/my-schedule" replace />;
  }

  return <Navigate to="/appointments" replace />;
}
